import { RealBufferedSource2k7dkofmgqbx9 as RealBufferedSource } from './RealBufferedSource.mjs';
import { RealBufferedSinkipqv3pv5gqfq as RealBufferedSink } from './RealBufferedSink.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function buffer(_this__u8e3s4) {
  return new (RealBufferedSource())(_this__u8e3s4);
}
function blackholeSink() {
  return new (BlackholeSink())();
}
function buffer_0(_this__u8e3s4) {
  return new (RealBufferedSink())(_this__u8e3s4);
}
var BlackholeSinkClass;
function BlackholeSink() {
  if (BlackholeSinkClass === VOID) {
    class $ {
      l3v(source, byteCount) {
        return source.o3v(byteCount);
      }
      lc() {
      }
      l6() {
      }
    }
    initMetadataForClass($, 'BlackholeSink', BlackholeSink);
    BlackholeSinkClass = $;
  }
  return BlackholeSinkClass;
}
//region block: exports
export {
  blackholeSink as blackholeSink1e341pykjnhp5,
  buffer as bufferbiiev5vr4b6f,
  buffer_0 as buffer10rjf0ze3bqic,
};
//endregion

//# sourceMappingURL=Okio.mjs.map
